import { render, staticRenderFns } from "./InvoicePolicyActionBox.vue?vue&type=template&id=33c115e1&scoped=true&"
import script from "./InvoicePolicyActionBox.vue?vue&type=script&lang=js&"
export * from "./InvoicePolicyActionBox.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePolicyActionBox.vue?vue&type=style&index=0&id=33c115e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c115e1",
  null
  
)

export default component.exports